/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocateProxiesEndpointRequest
 */
export interface LocateProxiesEndpointRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof LocateProxiesEndpointRequest
     */
    paths: Array<string>;
}

export function LocateProxiesEndpointRequestFromJSON(json: any): LocateProxiesEndpointRequest {
    return LocateProxiesEndpointRequestFromJSONTyped(json, false);
}

export function LocateProxiesEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocateProxiesEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paths': json['paths'],
    };
}

export function LocateProxiesEndpointRequestToJSON(value?: LocateProxiesEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paths': value.paths,
    };
}


